import { useSelector } from 'react-redux';
import { State } from '@/types';
import { NewSignUp, Ads } from '@/components';
import { DialogsProvider } from './DialogsContext';
import { PublicAuthLayout } from './PublicAuthLayout';

export const SignUpPage = () => {
  const { isLoggedIn } = useSelector(({ auth }: State) => auth);
  return (
    <DialogsProvider>
      {isLoggedIn ? (
        <Ads />
      ) : (
        <PublicAuthLayout variant='auth'>
          <NewSignUp isPublicAuthLayout />
        </PublicAuthLayout>
      )}
    </DialogsProvider>
  );
};
